import React from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';

export default class ColumnChartComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    const { height, values, categories, colors, options, yAxis } = this.props;
    const yMax = values && Math.max(...values);

    Highcharts.chart(this.containerRef.current, {
      chart: {
        type: 'column',
        grouping: false,
        backgroundColor: null,
        height,
        style: options.font,
      },
      plotOptions: options.plotOptions,
      title: { text: '' },
      subtitle: { text: '' },
      credits: { enabled: false },
      xAxis: {
        type: 'category',
        categories,
        minorTickLength: 0,
        tickLength: 0,
        labels: { style: options.font },
      },
      yAxis: {
        min: 0,
        max: yMax,
        allowDecimals: true,
        lineWidth: 1,
        title: { text: yAxis },
        labels: { style: options.font },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        enabled: true,
        headerFormat: '<b>{point.key}</b><br/>',
        pointFormat: '{point.y}',
        borderRadius: 0,
        shadow: false,
        style: options.font,
      },
      series: [
        {
          data: values,
          dataLabels: { enabled: false },
        },
      ],
      colors,
    });
  }

  render() {
    return <div ref={this.containerRef} />;
  }
}

ColumnChartComponent.propTypes = {
  height: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  colors: PropTypes.array.isRequired,
  options: PropTypes.object.isRequired,
  yAxis: PropTypes.string.isRequired,
};
